import { getItem } from 'helpers/storage';
import Button from 'lqa-ui/lib/Components/Button/index';
import React, { useEffect } from 'react';

export function ControlHub() {
    const url = `${Env.MICRO_APP_CONTROL_HUB_URL}?token=${getItem('user').token}`;

    useEffect(() => {
        window.open(url);
    }, []);

    return <Button title="Open Control Hub [BETA]" icon="link" href={url} type="anchor" />;
}
